import { PricingContext } from "../../src/screens/Components/PricingProvider";
import { getShortPlanId } from "../helpers";
import { plans } from "../_plans";
import { useBreakpointValue } from "@chakra-ui/react";
import { useContext } from "react";
import { useGetClaims } from "../../src/hooks";

export const useGetAnnualPlanPrice = (price) => price ? price * 10 : 0;

export const useGetProductsForPricingTable = () => {
    const { pricing, billingInterval } = usePricingContext()
    return plans(pricing, billingInterval === 'year')
}

export const usePricingContext = () => useContext(PricingContext) || {}

export const useIsDesktop = () => useBreakpointValue({ base: false, md: true }, { ssr: true })

export const useGetPlanId = () => {
    return useGetClaims()?.plan
}

export const useGetShortPlanId = (plan) => {
    const planId = useGetPlanId() || ""
    plan = getShortPlanId(plan || planId)
    return plan || 'free';
}